var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.getMenuFlat(
      'main',
      this.$store.state.selected_menu.pid
    )),function(slide,index){return _c('div',{key:index})}),(_vm.$store.state.selected_menu)?_c('LayoutHeadBanner',{attrs:{"itemData":_vm.$store.state.selected_menu}}):_vm._e(),_c('div',{staticClass:"container flex-box column layoutCards"},[_c('intersect',{on:{"enter":function($event){_vm.animate = true}}},[_c('div',{staticClass:"card-tabs"},[_c('swiper',{ref:"mySwiper",staticClass:"card-tabs-slider fadeUp",class:_vm.animate ? 'animate' : '',attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.getMenuFlat(
              'main',
              this.$store.state.selected_menu.pid
            )),function(slide,index){return _c('swiper-slide',{key:slide.key,staticClass:"card-tab",class:index === 0 ? 'current' : ''},[_c('router-link',{attrs:{"to":slide.full_url}},[_c('div',{staticClass:"img-box br-12"},[_c('img',{staticClass:"img-absolute br-12",attrs:{"src":_vm._.get(slide, 'media.optional_image.devices.desktop'),"alt":""}})])])],1)}),1)],1)]),_c('Breadcrumb',{staticClass:"layout3"})],1),_c('div',{staticClass:"container layout-outer cards-layout flex-box"},[_c('div',{staticClass:"layout-left"},[(_vm.$store.state.current_content)?_c('LayoutContent',{attrs:{"itemData":_vm.$store.state.current_content}}):_vm._e(),_c('div',{staticClass:"mobile-reason"},[(
          _vm._.get(
            this.$store.state.current_content,
            'secondary.usefull_tools.conf.enabled'
          ) == 1
        )?_c('UsefulTools',{attrs:{"itemData":_vm._.get(
            this.$store.state.current_content,
            'secondary.usefull_tools.conf'
          ),"bg":'noPadding whiteCol',"firstLook":2.3,"ipadLook":1.5}}):_vm._e()],1)],1),_c('intersect',{on:{"enter":function($event){_vm.animate2 = true}}},[_c('div',{staticClass:"layout-right fadeUp",class:_vm.animate2 ? 'animate' : ''},[(
            _vm._.get(
              _vm.$store.state.current_content,
              'secondary.custom_banner.conf.enabled'
            ) == 1
          )?_c('ApplicationLinkBox',{attrs:{"itemData":_vm._.get(
              this.$store.state.current_content,
              'secondary.custom_banner'
            )}}):_vm._e(),(
            _vm._.get(
              this.$store.state.current_content,
              'secondary.ProductBoxes.conf.enabled'
            ) == 1
          )?_c('ProductBoxes',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.ProductBoxes')}}):_vm._e()],1)])],1),_c('div',{staticClass:"container desktop-reason"},[(
          _vm._.get(
            this.$store.state.current_content,
            'secondary.usefull_tools.conf.enabled'
          ) == 1
        )?_c('UsefulTools',{attrs:{"itemData":_vm._.get(
            this.$store.state.current_content,
            'secondary.usefull_tools.conf'
          ),"bg":'noPadding whiteCol',"firstLook":2.3,"ipadLook":1.5}}):_vm._e()],1),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.ReasonsSlider.conf.enabled'
      ) == 1
    )?_c('ReasonsSlider',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.ReasonsSlider'),"noBg":'noBg'}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }